import { init } from '@sentry/nuxt'
import type { EventHint } from '@sentry/nuxt'

if (useRuntimeConfig().public.stage === 'live' || useRuntimeConfig().public.stage === 'beta') {
  init({
    dsn: useRuntimeConfig().public.sentryDSN,
    tracesSampleRate: parseFloat(useRuntimeConfig().public.sentryTracesSampleRate) || 0.05,
    profilesSampleRate: 1.0,
    environment: useRuntimeConfig().public.stage,
    release: useRuntimeConfig().public.releaseVersion,
    ignoreErrors: [
      'category_not_found', // our own 4XX errors
      'Product Not Found',
      'Java object is gone',
      'Unable to preload CSS',
      'AbortError', // HLS.js error
      'CustomEvent', // HLS.js error
      'Importing a module script failed',
      'Non-Error promise rejection',
      'TypeError: Failed to fetch', // Mostly Hls.js and Safari errors
      'Event `Event` (type=error) captured as promise rejection', // cookieyes error
      'TypeError: undefined is not an object (evaluating \'r["@context"].toLowerCase\')', // Safari structured data bug error
      '/_nuxt/builds/meta', // On new deployments, old json files are still being requested
      'dynamically imported module', // Error chunk. Happens on new deploy and will force a reload of the page.
      'window.webkit.messageHandlers', // CookieYes
      'logMutedMessage', // Ios edge error
      'showDialog rejects', // Uncatched showDialog handling
      'Object.hasOwn is not a function' // Trustbadge
    ],
    beforeSend (event: any, hint: EventHint) { // Ignore aborted ajax-calls
      const error = hint?.originalException as any

      if (
        error?.cause?.name.includes('AbortError') ||
        error?.cause?.message.includes('aborted') ||
        error?.name?.includes('AbortError') ||
        error?.message?.includes('The user aborted a request') ||
        error?.message?.includes('cancelled') ||
        error?.message?.includes('ECONNRESET') ||
        error?.message?.includes('NetworkError when attempting to fetch resource')
      ) {
        return null // skip logging
      }

      return event
    },
    debug: false
  })
}
